import { FiChevronDown } from 'react-icons/fi'
import { AiOutlineCheck } from 'react-icons/ai'
import { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useSpring, animated } from '@react-spring/web'
import { useAppState } from '../../providers/app-state'
import { useHttp } from '../../providers/http'
import TagManager from 'react-gtm-module'
import { useParams } from 'react-router-dom'
import ConsentInfoBlock from '../../components/consent-info-block'

const FinishedScreen = ({ pathname, index, goToByStepTitle }) => {
    const [loading, setLoading] = useState(true)
    const { state } = useAppState();
    const http = useHttp();
    const { orderId } = useParams();
    const [error, setError] = useState(null);

    const spring = useSpring({
        scale: loading ? 0 : 1
    })

    useEffect(() => {
        const {
            company,
            email,
            mileage,
            carMake,
            carModel,
            plate,
            name,
            phone,
            postalCode,
            countryCode,
            selectedRepairs,
            selectedUpsales,
            repairComment,
            selectedShop: {
                id
            },
            selectedDate,
            deliveryTime,
            pickupTime,
            pickupDate,
            timeOption,
            newsletter,
            withCar,
            comment,
            cvr,
            getCall,
            coupon
        } = state;

        if (!countryCode.value.match(/\+/)) {
            countryCode.value = "+" + countryCode.value
        }

        if (!name.value || !phone.value || !email.value) {
            return goToByStepTitle("mine info")
        }

        http.post(`/bookings/${(pathname.slice(1).match(/booking/i) || pathname.slice(1).match(/existingoffer/i)) ? "booking" : "offer"}`, {
            company,
            email: email.value,
            cvr,
            mileage,
            comments: comment + "\n" + repairComment,
            newsletter: +newsletter,
            model: `${carModel || ""} ${carMake || ""}`.trim(),
            name: name.value,
            phone: countryCode.value.length > 2 ? countryCode.value + phone.value : phone.value,
            plate: plate.value ? plate.value : "INGENBIL",
            postal_code: postalCode,
            shop_id: id,
            time_option: timeOption,
            time_rentalcar: +withCar,
            time_callme: +getCall,
            offer_number: orderId || "",
            time: selectedDate && `${selectedDate.format("YYYY-MM-DD")} ${timeOption === 2 ? "07:30" : deliveryTime || ""}`.trim(),
            time_pickup: (
                timeOption === 2
                    ? selectedDate && `${selectedDate.format("YYYY-MM-DD")} ${selectedDate.day() === 5 ? "15:30" : "16:30"}`
                    : pickupDate ? `${pickupDate.format("YYYY-MM-DD") || ""} ${pickupTime || ""}`.trim()
                        : null
            ),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            type: pathname.slice(1) === "booking" ? 1 : 0,
            coupons: [
                coupon
            ],
            repairs: {
                ...selectedRepairs.reduce((acc, cur) => {
                    return {
                        ...acc,
                        [cur.id]: {
                            name: cur.name,
                            comment: cur.commentField || ""
                        }
                    }
                }, {}),
                ...selectedUpsales.reduce((acc, cur) => {
                    return {
                        ...acc,
                        [cur.id]: {
                            name: cur.name,
                            comment: cur.commentField || "",
                            upsale: cur.upsale_pct
                        }
                    }
                }, {}),
            }
        })
            .then(res => {
                TagManager.dataLayer({
                    dataLayer: {
                        event: "FunnelEvent",
                        eventCategory: "funnel_submissions",
                        eventLabel: pathname.slice(1).match(/booking/i) ? "booking" : "offer",
                        stepNumber: index + 1,
                        stepOptions: res.data.id
                    }
                })
            })
            .catch(err => {
                setError(err)
            })
            .finally(() => setLoading(false))

    }, [pathname, http, state])

    if (error) {
        throw new Error(error)
    }

    if (loading) {
        return (
            <div
            >
                <Skeleton
                    height={90}
                    className="mb-10"
                />
                <Skeleton
                    height={350}
                    className="w-full md:w-1/3 mb-5"
                />
                <Skeleton
                    height={50}
                    className="w-full md:w-1/3"
                />
            </div>
        )
    }

    return (
        <div>
            <div
                className="space-y-3"
            >
                <animated.div
                    className='h-20 w-20 bg-green-400 rounded-full flex items-center justify-center mb-5'
                    style={spring}
                >
                    <AiOutlineCheck
                        size={30}
                        color="white"
                    />
                </animated.div>
                <div
                    className='flex space-x-5'
                >

                    <div
                        className='flex flex-col space-y-5'
                    >
                        <div>
                            <p
                                className="font-light text-sm"
                            >
                                Tusind tak fordi du har valgt Skorstensgaard
                            </p>
                            <p
                                className="text-xl md:text-2xl xl:text-4xl"
                            >
                                {
                                    `Du modtager snart en bekræftelse på ${pathname.slice(1).match(/booking/i) || pathname.slice(1).match(/existingoffer/i) ? "din booking" : "dit tilbud"}`
                                }
                            </p>
                        </div>
                        <p
                            className="font-light text-sm"
                        >
                            Vi ser frem til at kunne byde dig velkommen
                        </p>
                    </div>
                </div>
            </div>
            <hr
                className="w-32 my-10 border-skgGray"
            />
            <p
                className="mb-5"
            >
                Hvad sker der så nu?
            </p>
            {
                pathname.slice(1).match(/faatilbud/i)
                    ? (
                        <div
                            className="flex h-80"
                        >
                            <div
                                className="flex flex-col mr-3"
                            >
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <div
                                        className='w-3 h-3 rounded-full bg-skgRed mt-2 mb-1'
                                    />
                                    <div
                                        className="bg-skgBlue flex-1"
                                        style={{
                                            width: "1px"
                                        }}
                                    />
                                </div>
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <div>
                                        <FiChevronDown />
                                    </div>
                                    <div
                                        className="bg-skgBlue flex-1"
                                        style={{
                                            width: "1px"
                                        }}
                                    />
                                </div>
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <FiChevronDown />
                                </div>

                            </div>
                            <div
                                className="flex flex-col text-sm font-light w-full md:w-1/2 xl:w-1/3"
                            >
                                <div
                                    className="flex-1 mt-1"
                                >
                                    Vi har modtaget din forespørgsel
                                </div>
                                <div
                                    className="flex-1 -mt-2"
                                >
                                    Vi kontakter dig enten via Telefon eller Mail så snart tilbudet er færdigt
                                </div>
                                <div
                                    className="flex-1 -mt-1"
                                >
                                    Vi ses
                                </div>
                            </div>
                        </div>
                    )
                    : (
                        <div
                            className="flex h-80"
                        >
                            <div
                                className="flex flex-col mr-3"
                            >
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <div
                                        className='w-3 h-3 rounded-full bg-skgRed mt-2 mb-1'
                                    />
                                    <div
                                        className="bg-skgBlue flex-1"
                                        style={{
                                            width: "1px"
                                        }}
                                    />
                                </div>
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <div>
                                        <FiChevronDown />
                                    </div>
                                    <div
                                        className="bg-skgBlue flex-1"
                                        style={{
                                            width: "1px"
                                        }}
                                    />
                                </div>
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <FiChevronDown />
                                    <div
                                        className="bg-skgBlue flex-1"
                                        style={{
                                            width: "1px"
                                        }}
                                    />
                                </div>
                                <div
                                    className="flex-1 flex flex-col items-center"
                                >
                                    <FiChevronDown />
                                </div>

                            </div>
                            <div
                                className="flex flex-col text-sm font-light w-full md:w-1/2 xl:w-1/3"
                            >
                                <div
                                    className="flex-1 mt-1"
                                >
                                    Din reservation er blevet sendt ind og bliver håndteret hurtigst muligt
                                </div>
                                <div
                                    className="flex-1 -mt-2"
                                >
                                    Så snart vi har kontrolleret den aftalte dato og tid, vil du modtage den endelige bekræftelse på e-mail
                                </div>
                                <div
                                    className="flex-1 -mt-1"
                                >
                                    Derefter er det blot at møde op på det valgte værksted og indlevere køretøjet ved indskrivning
                                </div>
                                <div
                                    className="flex-1 -mt-1"
                                >
                                    Vi ses
                                </div>
                            </div>
                        </div>
                    )
            }
            <div
                className='font-light flex flex-wrap'
            >
                <a
                    className='bg-skgBlue rounded-md p-4 text-white uppercase mr-3 mb-3'
                    href={process.env.REACT_APP_WEBSITE_URL + "/nyheder"}
                >
                    se vores nyhedsmagasin
                </a>
                <a
                    className='bg-skgRed rounded-md p-4 text-white uppercase mb-3'
                    href={process.env.REACT_APP_WEBSITE_URL}
                >
                    Gå til forsiden
                </a>
            </div>
            <ConsentInfoBlock />
        </div>
    )
}

export default FinishedScreen;